import { Injectable } from '@angular/core';
import { Router, type UrlTree } from '@angular/router';
import {
  CurrentScopeFacade,
  ManagementService,
  OrganisationService,
} from '@principle-theorem/ng-principle-shared';
import { PracticeSetupWizard } from '@principle-theorem/principle-core';
import { snapshot, snapshotDefined } from '@principle-theorem/shared';
import { PracticeSetupWizardStore } from '../components/setup-wizard/setup-wizard.store';

@Injectable({
  providedIn: 'root',
})
export class SetupWizardGuard {
  constructor(
    private _router: Router,
    private _store: PracticeSetupWizardStore,
    private _currentScope: CurrentScopeFacade,
    private _managementService: ManagementService,
    private _organisation: OrganisationService
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    try {
      const practice = await snapshotDefined(
        this._currentScope.currentPractice$
      );
      if (!practice) {
        return false;
      }

      const brandSlug = await snapshot(this._currentScope.brandSlug$);
      if (!brandSlug) {
        return this._router.createUrlTree(['/']);
      }

      this._store.loadWizard(practice);

      const wizard = await PracticeSetupWizard.getByPractice(practice);
      if (!wizard || wizard.dismissedAt) {
        return this._redirectToDashboard(brandSlug, practice.slug);
      }

      const isManagementUser = await snapshot(this._managementService.user$);
      const currentStaffer = await snapshotDefined(this._organisation.staffer$);

      const hasAccess = await PracticeSetupWizard.hasAccess(
        wizard,
        currentStaffer,
        !!isManagementUser
      );

      if (!hasAccess) {
        return this._redirectToDashboard(brandSlug, practice.slug);
      }

      return true;
    } catch {
      return false;
    }
  }

  private _redirectToDashboard(
    brandSlug: string,
    practiceSlug: string
  ): UrlTree {
    return this._router.createUrlTree([
      brandSlug,
      practiceSlug,
      'schedule',
      'timeline',
    ]);
  }
}
